<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.techStatus === 'D'
              ? 'warning'
              : row.techStatus === 'S'
              ? 'success'
              : ''
          "
        >
          {{ row.v_techStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openDetailPage', {
                  pageType: 'detail',
                  params: { techCode: row.techCode },
                  query: { techNo: row.techNo }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="row.techStatus === 'N'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openDetailPage', {
                  pageType: 'edit',
                  params: { techCode: row.techCode },
                  query: { techNo: row.techNo }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-show="row.techStatus === 'N'"
          >
            <i class="el-icon-check tool-btn" @click="audit(row.techCode)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_same_order_copy') || '同单复制'"
            placement="top"
            v-if="row.techStatus != 'D'"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="sameCopy(row.techCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_reverse_copy') || '翻单复制'"
            placement="top"
            v-if="row.techStatus != 'D'"
          >
            <i
              class="el-icon-copy-document tool-btn"
              @click="differentCopy(row.techCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="row.techStatus === 'N'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.techCode)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    del(techCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .techInfoDelApi({ techCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    audit(techCode) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        const listTechCode = [techCode]
        this.$api
          .techInfoAuditApi({ listTechCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_audit_success') || '审核成功',
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    sameCopy(techCode) {
      this.$confirm(
        this.$l('INDEX.tips_tech_same_copy') || '是否确认同单复制该工艺单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .techInfoSameCopyApi({ techCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.btn_sure_copy_succeeded') || '复制成功',
              type: 'success'
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    differentCopy(techCode) {
      this.$emit('differentCopy', techCode)
    }
  }
}
</script>
